const state = {
  visible: false
}

const mutations = {
  SHOW_POSTER(state) {
    state.visible = true
  },
  HIDE_POSTER(state) {
    state.visible = false
  }
}

const getters = {
  visible: (state) => state.visible
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
